<template>
  <div class="box">
    <a-row :gutter="12">
      <a-col :span="24" style="margin-bottom: 30px;">
        <a-form-item label="分类名称">
          <div class="resource">
            <a-radio-group
              v-decorator="['resourceType']"
              @change.stop="hanleRadioChange"
            >
              <span v-if="list.length == '0'">不限</span>
              <a-radio-button
                style="margin-bottom: 10px;"
                v-for="(item, index) in list"
                :value="item"
                :key="index"
                @click="selectResource(item.id)"
                >{{ item.name }}</a-radio-button
              >
            </a-radio-group>
          </div>
        </a-form-item>
      </a-col>
    </a-row>

    <ResourceType
      v-if="jtypes.length > 0"
      :treeDatas="treeDatas"
      :list="jtypes"
      @handleItem="handleItem"
    />
  </div>
</template>
<script>
import { inquire, findPage } from "@/api/base/resource/manager";
export default {
  name: "ResourceType",
  props: {
    treeDatas: {
      type: Object,
      require: true
    },
    list: {
      type: Array,
      require: true
    },
    externalShow: String
  },
  data() {
    return {
      jtypes: []
    };
  },
  methods: {
    hanleRadioChange(e) {
      console.log("hanleRadioChange", e.target.value.jtypes);
      this.jtypes = e.target.value.jtypes ?? [];
      //   this.$emit("resourceTypeChange", e.target.value);
      // console.log('this.jtypes', this.jtypes)
    },
    selectResource(id) {
      console.log("selectResource");
      console.log("this.treeDatas", this.treeDatas);
      if (id) this.treeDatas["resourType"] = id;
      inquire({ partentid: id }).then();
      if (this.externalShow == "Y") this.treeDatas.externalShow = "Y";
      findPage(this.treeDatas).then(res => {
        console.log("res.result.rows", res.result.rows);
        this.$emit("handleItem", res.result.rows);
      });
    },
    resetChildren() {
      this.jtypes = [];
    },
    handleItem(row) {
      this.$emit("handleItem", row);
    }
  }
};
</script>

<style scoped>
.resource {
  height: 84px;
  overflow: hidden;
  overflow-y: auto;
}
</style>
